<template>
    <div class="mid-top">
        <div class="mid-top-one-box" >
            <div class="mid-top-one">
                <div class="mid-top-title">昨日用户数量</div>
                <div class="mid-top-num" style="margin-left:0.2rem">{{ top.yesterday_user_data || 0 }}</div>
          
            </div>
        </div>
        <div class="mid-top-one-box" >
            <div class="mid-top-one">
                <div class="mid-top-title">昨日订单数量</div>
                <div class="mid-top-num" style="margin-left:0.4rem">{{ top.yesterday_order_data || 0 }}</div>
             
            </div>
        </div>
        <div class="mid-top-one-box">
            <div class="mid-top-one">
                <div class="mid-top-title">昨日交易金额</div>
                <div class="mid-top-num">{{ top.yesterday_order_money || 0 }}</div>
             
            </div>
        </div>
        <div class="mid-top-one-box1" style="margin-top:0.6rem">
            <div class="mid-top-one1">
                <div class="mid-top-title1">覆盖总数量：</div>
                <div class="mid-top-num1">{{ top.total_device || 0 }}</div>      
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: {}, //访客相关
            money: {}, //成交额相关
            top:{},
        };
    },
    computed: {
        otherData: function () {
            return this.$store.getters.getState("otherData");
        },
    },
    watch: {
        otherData: function (newVal, oldVal) {
            this.top=newVal.top || "";
            this.user = newVal.user || "";
            this.money = newVal.money || "";
            // 特殊处理
            // this.user.today_yesterday = 1;
            // this.user.today_last_week = 1;
        },
    },
};
</script>

<style scoped>
.mid-top {
    position: absolute;
    /* width: 100%; */
    top: 1rem;
    height: 15%;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap; 
}
.mid-top-one-box {
    width: 27%;
    height: 80%;
    box-sizing: border-box;
    z-index: 0;
    padding: 0.1rem;;
}
.mid-top-one-box1 {
    height: 80%;
    box-sizing: border-box;
}
.mid-top-one1{
    display: flex;
    align-items: center;
}
.mid-top-one {
    width: 100%;
    height: 100%;
    position: relative;

    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
}
.mid-top-block-top {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 1px;
    width: 50%;
    height: 0.1rem;
    background: #000218;
    /* 000218 */
    transform: translateY(-100%) skew(-30deg);
    border-left: 2px solid #0efcff;
    border-top: 1px solid #0efcff;
}
.mid-top-block-top::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: -1px;
    right: 0;
    background: #000218;
    transform: translateX(91%) skew(60deg);
    border-left: 2px solid #0efcff;
}
.mid-top-block-bottom {
    display: inline-block;
    position: absolute;
    bottom: 2px;
    right: 0;
    width: 0.1rem;
    height: 25%;
    background: #000218;
    transform: translateX(100%) skewY(-30deg);
    border-right: 1px solid #0efcff;
    border-bottom: 2px solid #0efcff;
}
.mid-top-block-bottom::before {
    content: "";
    position: absolute;
    top: 0;
    left: 1px;
    width: 100%;
    height: 0.1rem;
    background: #000218;
    transform: translateY(-50%) skewY(50deg);
    border-bottom: 2px solid #0efcff;
}
.mid-top-block-left {
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0.3rem;
    height: 0.3rem;
    background: transparent;
    border-left: 5px solid #0efcff;
    border-bottom: 5px solid #0efcff;
    transform: translateX(-3px) translateY(3px);
}
.mid-top-block-left::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0.22rem;
    height: 0.2rem;
    background: #000218;
    transform: translateX(-65%) translateY(65%) rotateZ(45deg);
    border-top: 5px solid #0efcff;
    border-radius: 5px;
}
.mid-top-circle-box {
    position: absolute;
    top: -1px;
    left: 50%;
    height: 0.1rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    transform: translateY(-100%) skew(45deg);
    padding: 0 5px 3px;
    box-sizing: border-box;
}
.mid-top-circle {
    width: 5px;
    height: 100%;
    background: #0efcff;
    margin-right: 5px;
}
.mid-top-title {
    width: 100%;
    padding: 5% 0.22rem 2%;
    box-sizing: border-box;
    font-size: 0.24rem;
}
.mid-top-title1{
    box-sizing: border-box;
    font-size: 0.25rem;
}
.mid-top-num1{
     font-size: 0.4rem;
    font-weight: bold;
    text-transform: uppercase;
	text-shadow: #79284b 1px 4px ;

 
}
.mid-top-num {
      font-size: 0.4rem;
    font-weight: bold;
    text-transform: uppercase;
	text-shadow: #79284b 1px 4px ;
    padding-left: 0.22rem;
 
}
.mid-top-tips {
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    font-size: 0.12rem;
    padding: 0 0.1rem 2% 0;
    box-sizing: border-box;
}
.mid-top-tips span {
    margin-left: 0.1rem;
    font-weight: bold;
}
.tips-label {
    font-size: 0.25rem;
    font-weight: bold;
}
.tips-red {
    color: #ff0149;
}
.tips-green {
    color: #10d801;
}
</style>


// WEBPACK FOOTER //
// src/views/moudles/TrendMoudle.vue